import { render } from "./SocialBar.vue?vue&type=template&id=a23db0cc&scoped=true"
import script from "./SocialBar.vue?vue&type=script&lang=js"
export * from "./SocialBar.vue?vue&type=script&lang=js"

import "./SocialBar.vue?vue&type=style&index=0&id=a23db0cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a23db0cc"]])

export default __exports__